import React from 'react';

interface Props {
  message: string;
}

export const ErrorMessage: React.FC<Props> = ({ message }) => {
  return (
    <div className="membership-app__error-message">
      <svg
        className="membership-app__error-message-icon"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 0C3.589 0 0 3.589 0 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8Zm.77 12.61H7.23V11.13h1.54v1.482ZM7.23 9.502h1.54V3.39H7.23v6.112Z"
          fill="#1A1A1A"
        />
      </svg>
      <span className="membership-app__error-message-text">{message}</span>
    </div>
  );
};
